import { ReactComponent as PopUpDesign } from "../../../assets/img/transactionPopupDesign.svg";
import { ReactComponent as CautionIcon } from "../../../assets/img/notificationIcon.svg";
import { TableTransactionWorkflowDataType } from "./types";
import { InfoCircleOutlined as InfoCircle } from "@ant-design/icons";
import { formatCurrency, formatDate } from "../../../helper/helper";
import { PAYMENT_STATUS_VALUE, PaymentMethod } from "../../Utils/constants";
import OutlineButton from "../../UIKits/OutlineButton/OutlineButton";
import StatusIndicator from "../../StatusIndicator/StatusIndicator";
import TextDetail from "../../TextDetail/TextDetail";
import TextDetailContainer from "../../TextDetailContainer/TextDetailContainer";

interface TableTransactionWorkflowType {
  selectedTransaction: TableTransactionWorkflowDataType;
  type: string;
  hideAction: () => void;
  tableActions: {
    title: string;
    allowOnly: string | number;
    action: () => void;
    icon: React.ReactNode;
  }[];
}

const TableTransactionWorkflow = ({
  selectedTransaction,
  hideAction,
  tableActions,
  type,
}: TableTransactionWorkflowType) => {

  const statusToMatch = type === "wallet"
  ? selectedTransaction?.status
  : selectedTransaction?.paymentStatusValue;

   
  return (
    <div className="font-sans w-full  relative z-10 ">
      <div className="w-fit mx-auto -mt-5">
        <PopUpDesign className={"flex  mx-auto justify-center"} />
      </div>
      <div className="mt-10 space-y-2">
        <div className="flex gap-5 items-center">
          <p className="text-2xl font-semibold">{formatCurrency(selectedTransaction?.amount)}</p>
          {type === "vending" && <StatusIndicator incomingStatus={selectedTransaction?.paymentStatusValue!}  />}
          {type === "wallet" && <StatusIndicator incomingStatus={selectedTransaction?.status!} type="wallet" />}
        </div>
        <div className="flex gap-2 items-center">
          <p>
            {selectedTransaction?.transactionDate
              ? formatDate(selectedTransaction?.transactionDate)
              : formatDate(selectedTransaction?.invoiceDate)}
          </p>
          {type === "vending" && (
            <>
              <span className="flex w-[5px] h-[5px] bg-[#1A1B1DB2] rounded-full"></span>
              <p className="font-semibold">{selectedTransaction?.units}</p>
            </>
          )}
        </div>
      </div>
      <div className="flex gap-3 my-5">
        {tableActions.map(
          (action, index) =>
            action?.allowOnly === statusToMatch && (
              <OutlineButton
                key={index}
                label={action.title}
                onClick={action.action}
                icon={action.icon}
                className="!py-2 !px-3.5 text-sm"
              />
            )
        )}
      </div>
      {PAYMENT_STATUS_VALUE.FAILED === selectedTransaction?.paymentStatusValue && (
        <p className="text-sm flex items-center gap-2 text-customRed bg-lightRed py-1.5 px-4 rounded-lg w-fit">
          <CautionIcon />
          <span className="font-medium">Reason for failure:</span> Couldn’t talk to remita
        </p>
      )}

      {PAYMENT_STATUS_VALUE.PENDING === selectedTransaction?.paymentStatusValue && (
        <p className="text-sm flex   items-center font-medium  gap-2 text-[#DD8304] bg-[#FFF8EF] py-1.5 px-4 mb-2 rounded-lg w-full">
          <InfoCircle className="w-4 h-4 " />
          Transaction processing
        </p>
      )}
      <div className="space-y-3 ">
        <p className="text-sm text-[#1C1F1DCC] font-medium">{type === "vending" ? "Details" : "Transaction details"}</p>
        <TextDetailContainer>
          {type === "vending" && <TextDetail title="Customer Name" value={selectedTransaction?.customerName} />}
          <TextDetail title="Amount" value={formatCurrency(selectedTransaction?.amount)} />
          {type === "wallet" && (
            <TextDetail title="Balance after transaction" value={formatCurrency(selectedTransaction?.balanceAfter)} />
          )}
          {type === "vending" && <TextDetail title="Equivalent unit" value={selectedTransaction?.units} />}
          <TextDetail title="Invoice number" value={selectedTransaction?.invoiceNumber} />

          <TextDetail title="RRR" value={selectedTransaction?.rrr} />
          {type === "vending" && selectedTransaction?.paymentMethodValue && (
            <TextDetail
              title="Payment Method"
              value={selectedTransaction?.paymentMethodValue  === PaymentMethod.Wallet ?  "Wallet" :  "Remita"}
            />
          )}
        </TextDetailContainer>
      </div>
    </div>
  );
};

export default TableTransactionWorkflow;
